const initialState = {
    car_addOn_selection: JSON.parse(localStorage.getItem('car_addOn_selection')) || [],
};

const carAddOnSelectionReducer = (state = initialState, action) => {
    switch (action.type) {
        case 'SET_CAR_ADD_ON_SELECTION':
            localStorage.setItem('car_addOn_selection', JSON.stringify(action.payload));
            return {
                ...state,
                car_addOn_selection: action.payload,
            };
        default:
            return state;
    }
};

export default carAddOnSelectionReducer;